var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expand-transition',[_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.VShow),expression:"VShow"}],staticClass:"no-gutters"},[_c('v-col',[(_vm.VIf)?_vm._t("default"):_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }